import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-8 p-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Sub-category", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://via.placeholder.com/75x30.png?text=category",
    alt: "category"
  })
], -1)
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = {
  key: 0,
  class: "col-3 small"
}
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.name), 1),
      (_ctx.categories.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "border p-2 mb-4 row"
              }, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", null, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'categories-details', params: { id: item.id } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]),
                (_ctx.identityStore.isAdmin())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createTextVNode(" For admin: "),
                      _createVNode(_component_RouterLink, {
                        to: { name: 'categories-details', params: { id: item.id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Details")
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createTextVNode(" | "),
                      _createVNode(_component_RouterLink, {
                        to: { name: 'categories-edit', params: { id: item.id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Edit")
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createTextVNode(" | "),
                      _createVNode(_component_RouterLink, {
                        to: { name: 'categories-delete', params: { id: item.id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Delete")
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "border p-2 mb-4 row"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: _ctx.getProductImageByBarcode(item.barcode),
              alt: "product"
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h4", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'products-details', params: { id: item.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, " €" + _toDisplayString(item.bestPrice > 0 ? item.bestPrice : ''), 1)
        ]))
      }), 128))
    ])
  ]))
}